import { ALL_NETWORKS, CURRENCY_DATA, Network } from ':fat/core/networks';

export async function getRates() {
  const rates = await Promise.all(ALL_NETWORKS.map(getRate));
  return Object.fromEntries(ALL_NETWORKS.map((network, i) => [network, rates[i]])) as Record<
    Network,
    number
  >;
}

async function getRate(network: Network) {
  const { symbol } = CURRENCY_DATA[network];
  const response = await fetch(`https://api.exchange.coinbase.com/products/${symbol}-USD/ticker`);
  const body = (await response.json()) as { price: string };
  return parseFloat(body.price);
}
